var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_9331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.875 9C9.06847 9 10.2131 8.52589 11.057 7.68198C11.9009 6.83807 12.375 5.69347 12.375 4.5C12.375 3.30653 11.9009 2.16193 11.057 1.31802C10.2131 0.474106 9.06847 0 7.875 0C6.68153 0 5.53693 0.474106 4.69302 1.31802C3.84911 2.16193 3.375 3.30653 3.375 4.5C3.375 5.69347 3.84911 6.83807 4.69302 7.68198C5.53693 8.52589 6.68153 9 7.875 9ZM6.26836 10.6875C2.80547 10.6875 0 13.493 0 16.9559C0 17.5324 0.467578 18 1.04414 18H11.3484C11.2395 17.6906 11.2184 17.3531 11.2992 17.0227L11.8266 14.9098C11.925 14.5125 12.1289 14.1539 12.4172 13.8656L13.834 12.4488C12.7055 11.359 11.1727 10.6875 9.47813 10.6875H6.26836ZM21.5789 8.28633C21.0305 7.73789 20.141 7.73789 19.5891 8.28633L18.5555 9.31992L21.0516 11.816L22.0852 10.7824C22.6336 10.234 22.6336 9.34453 22.0852 8.79258L21.5789 8.28633ZM13.2152 14.6602C13.0711 14.8043 12.9691 14.9836 12.9199 15.184L12.3926 17.2969C12.3434 17.4902 12.3996 17.6906 12.5402 17.8313C12.6809 17.9719 12.8812 18.0281 13.0746 17.9789L15.1875 17.4516C15.3844 17.4023 15.5672 17.3004 15.7113 17.1562L20.2535 12.6105L17.7574 10.1145L13.2152 14.6602Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_9331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit_profile.6f55e11a47132cdab109c5b530899834.svg";
export { ForwardRef as ReactComponent };